import { Card, CardContent } from '@/components/ui/card';
import { TrendingUp, Users, Tv, Award, Medal, Book } from 'lucide-react';

const Stats = () => {
  const stats = [
    {
      icon: <Tv className="w-8 h-8 text-slate-600" />,
      number: '50+',
      label: 'TV Appearances',
      description: 'As the go-to finance guy'
    },
    {
      icon: <Medal className="w-8 h-8 text-slate-500" />,
      number: '100M+',
      label: 'Assets Under Management',
      description: 'Across all platforms'
    },
    {
      icon: <TrendingUp className="w-8 h-8 text-slate-700" />,
      number: '25+',
      label: 'Years Experience',
      description: 'As Independent RIA'
    },
    {
      icon: <Book className="w-8 h-8 text-slate-800" />,
      number: '3',
      label: 'Books Authored',
      description: 'One Hit the Amazon Best Seller List'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-4 text-slate-800">
          At Bridgeriver Advisors we make the complex, simple.
        </h2>
        <p className="text-lg text-center mb-12 text-slate-600">
          100% Privately owned, Independent RIA firm headquartered in Michigan with clients nationwide
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat, index) => (
            <Card key={index} className="text-center p-6 hover:shadow-lg transition-shadow duration-300 border-2 hover:border-slate-300 bg-slate-50">
              <CardContent className="p-0">
                <div className="flex justify-center mb-4">
                  {stat.icon}
                </div>
                <div className="text-3xl font-bold text-slate-800 mb-2">
                  {stat.number}
                </div>
                <div className="text-lg font-semibold text-slate-700 mb-1">
                  {stat.label}
                </div>
                <div className="text-sm text-slate-600">
                  {stat.description}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;